import React, { useState } from "react";
import Image from 'next/image'
import { Transition } from "@headlessui/react";
import Link from 'next/link'
import router from 'next/router'

const NaviBar = () =>{

    const [isOpen, setIsOpen] = useState(false);
    const myRef = React.createRef();
    const url = '/';
    const urlAccountant = '/registro-contador';

    const handleClick = ()=> {
        router.push(url);
    }
    const handleContador = () => {
        router.push(urlAccountant);
    }
    return (
        <div className="w-full fixed top-0 z-50">
            <nav className="bg-secondary">
                <div className="navbar-container mx-auto" id="header_top">
                <div className="flex max-w-screen-lg mx-auto xs:justify-around lg:justify-center h-16">
                    <div className="flex w-auto lg:w-full justify-between items-center">
                        <div className="flex-shrink-0 mr-8">
                            <Link href="/" to="/" rel='follow'> 
                                <a onClick={handleClick} rel='follow'>
                                    <Image loading="lazy" 
                                    src='https://cdn.fixat.mx/assets/img/no-webp/logo-principal-fixat.png'
                                    alt="Logo principal de Fixat®" 
                                    title="Fixat® | Declaramos tus impuestos"
                                    height="44px"
                                    width="169px"
                                    />
                                </a>
                            </Link>
                        </div>
                    <div className="xs:hidden lg:block ">
                        <div className="ml-10 flex items-baseline space-x-4 navbar">
                            <Link to="" href="/#section_001" rel='follow'> 
                            <a className="navbar px-3 py-2" rel='follow'>¿Cómo funciona?</a>
                            </Link>
                            <Link to="" href="/#section_004" rel='follow'> 
                            <a className="navbar px-3 py-2" rel='follow'>Servicios</a>
                            </Link>
                            <Link to="" href="/#section_005" rel='follow'> 
                            <a className="navbar px-3 py-2" rel='follow'>Acerca de FIXAT®</a>
                            </Link>
                            <Link to="" href="/#section_007" rel='follow'> 
                            <a className="navbar px-3 py-2" rel='follow'>Testimonios</a>
                            </Link>
                            <Link to="" href="/#section_009" rel='follow'> 
                            <a className="navbar px-3 py-2" rel='follow'>Ayuda</a>
                            </Link>
                            {/*
                            <Link to="registro-contador" href="/registro-contador" onClick={handleContador}>
                                <a className="navbar px-3 py-2">¿Eres contador?</a>
                            </Link>
                            */}
                        </div>
                    </div>
                    </div>
                    <div className="flex xs:block lg:hidden ml-16 -mr-3">
                    <button
                        onClick={() => setIsOpen(!isOpen)}
                        type="button"
                        className="bg-transparent inline-flex items-center justify-center p-2 rounded-md text-white-700 text-white md:hover:bg-transparent"
                        aria-controls="mobile-menu"
                        aria-expanded="false"
                    >
                        <span className="sr-only">Open main menu</span>
                        {!isOpen ? (
                        <svg
                            className="block h-12 w-12 text-white"
                            xmlns="http://www.w3.org/2000/svg"
                            fill="none"
                            viewBox="0 0 24 24"
                            stroke="currentColor"
                            aria-hidden="true"
                        >
                            <path
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            strokeWidth="2"
                            d="M4 6h16M4 12h16M4 18h16"
                            />
                        </svg>
                        ) : (
                        <svg
                            className="block h-12 w-12"
                            xmlns="http://www.w3.org/2000/svg"
                            fill="none"
                            viewBox="0 0 24 24"
                            stroke="currentColor"
                            aria-hidden="true"
                        >
                            <path
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            strokeWidth="2"
                            d="M6 18L18 6M6 6l12 12"
                            />
                        </svg>
                        )}
                    </button>
                    </div>
                </div>
                </div>

                <Transition
                show={isOpen}
                enter="transition ease-out duration-50 transform"
                enterFrom="opacity-0 scale-95"
                enterTo="opacity-100 scale-100"
                leave="transition ease-in duration-75 transform"
                leaveFrom="opacity-100 scale-100"
                leaveTo="opacity-0 scale-95"
                >
                {() => (
                    <div ref={myRef} className="xs:block lg:hidden" id="mobile-menu">
                        <div className="px-2 pt-2 pb-3 space-y-1 sm:px-3">
                        <Link to="" href="/#section_001" rel='follow'> 
                            <a rel='follow' className="md:hover:bg-blue-300 text-white block px-3 py-2 rounded-md text-base font-medium">¿Cómo funciona?</a>
                            </Link>
                            <Link rel='follow' to="" href="/#section_004"> 
                            <a rel='follow' className="md:hover:bg-blue-300 text-white block px-3 py-2 rounded-md text-base font-medium">Servicios</a>
                            </Link>
                            <Link rel='follow' to="" href="/#section_005"> 
                            <a rel='follow' className="md:hover:bg-blue-300 text-white block px-3 py-2 rounded-md text-base font-medium">Acerca de FIXAT®</a>
                            </Link>
                            <Link rel='follow' to="" href="/#section_007"> 
                            <a rel='follow' className="md:hover:bg-blue-300 text-white block px-3 py-2 rounded-md text-base font-medium">Testimonios</a>
                            </Link>
                            <Link rel='follow' to="" href="/#section_009"> 
                            <a rel='follow' className="md:hover:bg-blue-300 text-white block px-3 py-2 rounded-md text-base font-medium">Ayuda</a>
                            </Link>
                            <Link rel='follow' to="registro-contador" href="/registro-contador" onClick={handleContador}>
                            <a rel='follow' className="md:hover:bg-blue-300 text-white block px-3 py-2 rounded-md text-base font-medium">¿Eres contador?</a>
                            </Link>
                        </div>
                    </div>
                )}
                </Transition>
            </nav>
        </div>
    );
}

export default NaviBar;